import { SpaceStorySection } from '@/scenes/Stories/SpaceStory/styles';

import Mobile from '@/assets/Bearanger/mobile.svg';
import Desktop from '@/assets/Bearanger/desktop.svg';
import { useEffect, useRef, useState } from 'react';
import { gsap, Power4 } from 'gsap';

const SpaceStory = () => {
  const sectionRef = useRef(null);

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (!loaded) return;

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: 'top 92%',
      },
    });
    tl.fromTo(
      sectionRef.current,
      {
        opacity: 0,
        yPercent: 10,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 1,
        ease: Power4.easeInOut,
      },
    );
  }, [loaded]);

  return (
    <SpaceStorySection ref={sectionRef}>
      <Mobile className="mobile" viewBox="0 0 375 766" />
      <Desktop className="desktop" viewBox="0 0 1440 573" />
    </SpaceStorySection>
  );
};

export default SpaceStory;
